import React, { useState, useEffect } from "react";
import NewsList from "../../blocks/components/news-list/NewsList";

function NewsBlock({ newsNumber, newsCategory, newsSize }) {
  const [posts, setPosts] = useState([]);
  const [spinner, setSpinner] = useState(true);

  const formatDate = (inputDate) => {
    const date = new Date(inputDate);
    if (isNaN(date)) return null;

    const day = date.getDate();
    const month = date.toLocaleString("en-GB", { month: "long" });
    const year = date.getFullYear();
    const fullDate = `${day} ${month} ${year}`;

    return fullDate;
  };

  useEffect(() => {
    const fetchPosts = async () => {
      const categoryParameter =
        newsCategory && newsCategory !== "all"
          ? `&categories=${newsCategory}`
          : "";
      try {
        setSpinner(true);
        const response = await fetch(
          `/wp-json/wp/v2/posts?_embed&_fields=id,title,link,excerpt,date,_links.wp:featuredmedia,_embedded.wp:featuredmedia&per_page=${newsNumber}${categoryParameter}`
        );

        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const posts = await response.json();
        const postsInfo = posts.map((post) => ({
          id: post?.id,
          title: post?.title?.rendered,
          link: post?.link,
          excerpt: post?.excerpt?.rendered,
          thumbnailUrl:
            post?._embedded?.["wp:featuredmedia"]?.[0]?.media_details?.sizes
              ?.medium_large?.source_url ||
            post?._embedded?.["wp:featuredmedia"]?.[0]?.source_url,

          thumbnailAlt:
            post?._embedded?.["wp:featuredmedia"][0]?.alt_text || "",
          date: post?.date && formatDate(post?.date),
        }));
        setSpinner(false);
        setPosts(postsInfo);
      } catch (error) {
        console.error("Fetch error:", error);
      }
    };

    fetchPosts();
  }, []);

  return <NewsList posts={posts} spinner={spinner} newsSize={newsSize} />;
}

export default NewsBlock;
